export interface SupportContact {
  labelKey: string;
  phone: string;
  isEmergency?: boolean;
}

export const supportContacts: SupportContact[] = [
  { labelKey: "support.billingQuestions", phone: "410-313-2058" },
  { labelKey: "support.billingFax", phone: "410-313-3239" },
  { labelKey: "support.sewerBackUp", phone: "410-313-4900" },
  { labelKey: "support.meterDepartment", phone: "410-313-4980" },
  { labelKey: "support.waterQuality", phone: "410-313-4997" },
  {
    labelKey: "support.meterChangeOut",
    phone: "410-313-4988",
    isEmergency: true,
  },
  {
    labelKey: "support.utilityStakeOut",
    phone: "410-313-4982",
    isEmergency: true,
  },
  { labelKey: "support.emergencies", phone: "410-313-4900", isEmergency: true },
  {
    labelKey: "support.afterHoursEmergencies",
    phone: "410-313-2929",
    isEmergency: true,
  },
];

export const supportEmail = "billing@howardcountymd.gov";
